import { styled } from '@mui/material'
import {
  Call as CallIcon,
  CloseRounded as CloseIcon,
} from '@mui/icons-material'
import { ControlButton } from './control-button'
import { closePvCallManager } from '$logic/router'
import { callService, callStorage, useCallStoragePvMeta } from '$logic/call'
import { t } from '$i18n'

const Container = styled('div')`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 48px;
`

export function EndedCallControls() {
  const { status } = useCallStoragePvMeta()

  return (
    <Container>
      <ControlButton
        color="gray"
        caption={t('call.cancel')}
        icon={<CloseIcon />}
        onClick={() => {
          closePvCallManager()
          setTimeout(() => callStorage.resetPvMeta(), 300)
        }}
      />

      <ControlButton
        color="success"
        caption={
          status === 'busy' || status === 'timed-out'
            ? t('call.retry')
            : t('call.callAgain')
        }
        icon={<CallIcon />}
        onClick={async () => {
          const { roomId: pvCallRoomId } = callStorage.getPvMeta()
          await callService.startCall(pvCallRoomId, 'PV', 'call')
        }}
      />
    </Container>
  )
}
